const hasDuplicateCoordinatesOnly = (coords) => {
  const stringifiedCoords = coords.map((coord) => JSON.stringify(coord));

  return new Set(stringifiedCoords).size === 1;
};

export default hasDuplicateCoordinatesOnly;
